import { useLocation } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import { CONTACT_INFO } from '../../data/content';

const FloatingWhatsApp = () => {
  const location = useLocation();
  if (location.pathname.startsWith('/admin')) return null;

  return (
    <a
      data-testid="floating-whatsapp"
      href={`https://wa.me/${CONTACT_INFO.whatsappNumber}?text=${encodeURIComponent(
        'Olá! Vim pelo site e gostaria de mais informações.'
      )}`}
      target="_blank"
      rel="noreferrer"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-6 right-6 z-[70] group"
    >
      <span className="absolute inset-0 rounded-full bg-emerald-500 animate-ping opacity-20" />
      <span className="relative flex w-14 h-14 rounded-full bg-emerald-500 items-center justify-center shadow-[0_10px_30px_rgba(16,185,129,0.45)] group-hover:scale-110 group-hover:bg-emerald-400 transition-all duration-300">
        <MessageCircle className="w-7 h-7 text-white" />
      </span>
      <span className="pointer-events-none absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-[#0A2847] border border-emerald-400/30 px-4 py-2 text-xs font-mono uppercase tracking-widest text-emerald-300 opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
        Fale conosco
      </span>
    </a>
  );
};

export default FloatingWhatsApp;
